<template>
  <div v-if="hasNotifications" class="notifications">
    <ENotificationPill ref="toggle" v-on-clickaway="hideList" v-focus="visible" @click="toggle" />
    <ENotificationList :visible="visible" :blog-url="blogUrl" :read-more-label="readMoreLabel" />
    <ENotificationPopup />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';
import { mixin as focus } from 'vue-focus';

import { sendEvent, sendCoreAnalyticsEvent } from '~~/common/js/client/analytics';
import { getNotifications } from '~~/common/js/client/notifications';
import mockNotifications from '~~/common/js/test-utils/mocks/notifications';

import ENotificationList from './list';
import ENotificationPill from './pill';
import ENotificationPopup from './popup';

export default {
  name: 'ENotifications',
  components: {
    ENotificationList,
    ENotificationPill,
    ENotificationPopup,
  },
  mixins: [clickaway, focus],
  props: {
    blogUrl: {
      type: String,
      required: true,
    },
    readMoreLabel: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    ...mapState('global', ['locale']),
    ...mapState('user', [
      'bingMarketCode',
      'defaultMarket',
      'browser',
    ]),
    hasNotifications() {
      const notifications = this.$store.getters['notifications/get'];
      return notifications && notifications.length > 0;
    },
  },
  beforeMount() {
    const market = this.bingMarketCode || this.defaultMarket;

    if (this.hasNotifications) {
      return;
    }

    const promise = process.env.isDev ?
      Promise.resolve(mockNotifications) :
      getNotifications(this.locale, market, this.browser);

    promise
      .then((response) => {
        this.$store.commit('notifications/setNotifications', response);
      })
      .catch((err) => this.$sentry.captureException(err));
  },
  methods: {
    sendEvent(name) {
      sendEvent(name, { origin: 'center' });
      sendCoreAnalyticsEvent(name, { origin: 'center' });
    },
    setVisible(value) {
      this.visible = value;
      if (this.visible) {
        this.$emit('visible');
      }
    },
    toggle() {
      const visible = !this.visible;
      this.setVisible(visible);
      if (visible) {
        this.sendEvent('all_notification_toggleNotificationCenter');
      }
    },
    hideList({ target }) {
      const { $el } = this.$refs.toggle;
      if (target !== $el && !$el.contains(target)) {
        this.setVisible(false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.notifications {
  display: none;

  @include tablet {
    position: relative;
  }

  @include desktop {
    display: block;
  }
}
</style>
